let order = require('../order');
let account = require('../groups/account');
let orders = require('../../actions/account/orders');
let documents = require('../../actions/account/documents');
let error = require('../../actions/error');
let content = require('../../actions/layout/content');
let utils = require('../../actions/utils');
let user = require('../../actions/user');
let currentOrderGroups = require('../groups/account/current-order');
let customOrderGroups = require('../groups/custom-order');
let { restoreStateGroup } = require('../groups/custom-order/index');
let customOrder = require('../../actions/custom-order');
let analytics = require('../../actions/analytics');
let { raiseEventsOnOrderLoaded } = require('../groups/analytics');
let { saveFilterValues } = require('../account/editable-order');
let currentOrder = require('../../actions/account/current-order');
let { updateOrderData } = require('../groups/account');
let form = require('../../actions/form');
const ordersComputedActions = require('../../actions/computed/account/orders');
const currentOrderActions = require('../../actions/account/current-order');

const moveOrderToNextState = [
    [
        orders.ifAcceptLicenseAgreement,
        {
            yes: [
                [
                    orders.acceptLicenseAgreement,
                    {
                        success: [orders.setIsLicenseAgreementAccepted],
                        error: [error.internalError('orders.acceptLicenseAgreement')]
                    }
                ]
            ],
            no: []
        }
    ],
    [
        orders.ifAcceptDataChanged,
        {
            yes: [
                [
                    orders.confirmDataChanged,
                    {
                        success: [orders.setDataChangedConfirmed],
                        error: [error.internalError('orders.confirmDataChanged')]
                    }
                ]
            ],
            no: []
        }
    ],
    [
        orders.moveOrderToNextState,
        {
            success: [
                currentOrder.updateOrder(['stateId', 'exportResult', 'necessaryDocuments', 'paymentForm', 'price']),
                currentOrder.filterOptionalExportColumnsOnOrderDisable,
                ...raiseEventsOnOrderLoaded,
                orders.ifOrderDataChanged,
                {
                    yes: [
                        orders.setIsNeedToConfirmDataVersionChange,
                        ...customOrderGroups.setOrderParametersGroup,
                        customOrder.setComputedFields,
                        ...restoreStateGroup,
                        utils.unset(['account', 'orders', 'currentOrder', 'tooltips', 'hideDataChangedMustBeConfirmed'])
                    ],
                    no: []
                }
            ],
            error: [error.internalError('orders.moveOrderToNextState')],
            temporarilyUnavailable: [
                utils.set(['account', 'orders', 'disableContinue'], true)
            ]
        }
    ]
];

const applyLocalChanges = [
    content.setIsLoading(true),
    [
        orders.isFilterValuesChanged,
        {
            true: [
                ...saveFilterValues,
                utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'filterValuesChanged'])
            ],
            false: []
        }
    ],
    [
        orders.isPaymentTypeChanged,
        {
            true: [
                [
                    orders.setPaymentType,
                    {
                        success: [
                            utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId'])
                        ],
                        error: [error.internalError('orders.setPaymentType')]
                    }
                ]
            ],
            false: []
        }
    ],
    [
        documents.applyLocalChangesAddOrRemoveDocTypes,
        {
            success: [
                utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'addOrRemove'])
            ],
            error: []
        }
    ],
    [
        documents.applyLocalChangesDeleteDocs,
        {
            success: [
                utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'delete'])
            ],
            error: [error.internalError('documents.applyLocalChangesDeleteDocs')]
        }
    ],
    [
        documents.applyLocalChangesUploadDocs,
        {
            success: [
                utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload']),
                utils.unset(currentOrderActions.PATHS.showUploadFailTooltip),
                utils.unset(currentOrderActions.PATHS.showBillDocumentMustBeAttached)
            ],
            errorTooBigFile: [
                utils.set(currentOrderActions.PATHS.showUploadFailTooltip, true)
            ],
            error: [error.internalError('documents.applyLocalChangesUploadDocs')]
        }
    ],
    [
        user.isUserChanged,
        {
            true: [
                ...currentOrderGroups.setUserGroup,
                utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser'])
            ],
            false: []
        }
    ],
    [
        orders.isManagerChanged,
        {
            true: [
                [
                    orders.setManager,
                    {
                        success: [
                            utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager'])
                        ],
                        error: [error.internalError('orders.setManager')]
                    }
                ]
            ],
            false: []
        }
    ],
    // елси FilterValues заказа сейчас редактируются, то пользовательно должен Сохрнанить/Отменить их изменения
    // прежде чем мы скачаем все новые данные заказа
    [
        customOrder.isFilterValuesChanged,
        {
            yes: [
                utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showChangesMustBeSavedOrCancelled'], true),
                utils.scrollTop
            ],
            no: [
                // обновляем данные заказа
                orders.orderIdToArgs,
                ...account.getOrder,
                orders.unsetLocalChangesIfEmpty
            ]
        }
    ],
    content.setIsLoading(false)
];

module.exports = {
    wrapperOnLoad: [
        [
            user.isUnauthorized,
            {
                yes: [
                    orders.restoreLocalChanges,
                    orders.restoreAccountOrderState,
                    ...order.onLoad
                ],
                no: []
            }
        ]
    ],
    archiveOrder: [
        analytics.argsValueEvent({ category: 'button_remove_order', action: 'click' }),
        [
            orders.archiveOrder,
            {
                success: [
                    currentOrder.updateOrder(['stateId']),
                    ...raiseEventsOnOrderLoaded
                ],
                error: [error.internalError('orders.archiveOrder')]
            }
        ]
    ],
    tryMoveOrderToNextState: [
        utils.set(['account', 'orders', 'currentOrder', 'isLoading'], true),
        [
            orders.ifLicenseMustBeAccepted,
            {
                yes: [utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showLicenseMustBeAccepted'], true)],
                no: []
            }
        ],
        [
            orders.ifUserMustBeSelected,
            {
                yes: [
                    utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'], true)
                ],
                no: []
            }
        ],
        [
            customOrder.isFilterValuesChanged,
            {
                yes: [
                    utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showChangesMustBeSavedOrCancelled'], true)
                ],
                no: []
            }
        ],
        [
            orders.ifPriceMustBeBiggerThenZero,
            {
                yes: [
                    utils.set(currentOrderActions.PATHS.showPriceMustBeBiggerThanZero, true)
                ],
                no: []
            }
        ],
        [
            orders.ifBillMustBeAttached,
            {
                yes: [
                    utils.set(currentOrderActions.PATHS.showBillDocumentMustBeAttached, true)
                ],
                no: []
            }
        ],
        [
            orders.ifExportResultMustBeAttached,
            {
                yes: [
                    utils.set(currentOrderActions.PATHS.isExportResultMustBeAttached, true)
                ],
                no: []
            }
        ],
        [
            orders.ifCanMoverOrderToNextState,
            {
                yes: [...moveOrderToNextState],
                no: []
            }
        ],
        [
            orders.ifNeedToScrollTop,
            {
                yes: [
                    utils.scrollTop
                ],
                no: []
            }
        ],
        utils.set(['account', 'orders', 'currentOrder', 'isLoading'], false),
        [
            orders.ifContinueDisabled,
            {
                yes: [
                    [
                        currentOrder.waitBackendStandardState,
                        {
                            success: [
                                utils.unset(['account', 'orders', 'disableContinue'])
                            ],
                            error: []
                        }
                    ]
                ],
                no: []
            }
        ]
    ],

    payOnline: [
        analytics.argsValueEvent({ category: 'button_pay_order_page_money_hold', action: 'click' }),
        content.setIsLoading(true),
        [
            orders.payOnline,
            {
                success: [
                    orders.setOrderPaymentForm
                ],
                error: [
                    error.internalError('orders.payOnline')
                ]
            }
        ],
        content.setIsLoading(false)
    ],

    uploadDocument: [
        [
            utils.isLocalEditMode,
            {
                true: [
                    documents.uploadDocumentLocal
                ],
                false: [
                    [
                        documents.uploadDocument,
                        {
                            success: [
                                documents.updateDocumentsInState,
                                utils.unset(currentOrderActions.PATHS.showUploadFailTooltip),
                                utils.unset(currentOrderActions.PATHS.showBillDocumentMustBeAttached)
                            ],
                            errorTooBigFile: [
                                utils.set(currentOrderActions.PATHS.showUploadFailTooltip, true)
                            ],
                            error: [error.internalError('documents.uploadDocument')]
                        }
                    ]
                ]
            }
        ]
    ],
    setDocumentType: [
        [
            documents.isCheckboxChecked, {
                yes: [
                    [
                        utils.isLocalEditMode,
                        {
                            true: [
                                documents.addDocumentTypeLocal
                            ],
                            false: [
                                [
                                    documents.addDocumentType,
                                    {
                                        success: [],
                                        error: [error.internalError('documents.addDocumentType')]
                                    }
                                ]
                            ]
                        }
                    ]
                ],
                no: [
                    [
                        utils.isLocalEditMode,
                        {
                            true: [
                                documents.addDocumentTypeLocal
                            ],
                            false: [
                                [
                                    documents.removeDocumentType,
                                    {
                                        success: [],
                                        error: [error.internalError('documents.removeDocumentType')]
                                    }
                                ]
                            ]
                        }
                    ]
                ]
            }
        ],
        [
            utils.isLocalEditMode,
            {
                true: [
                    [
                        utils.isSaveLocalChanges,
                        {
                            yes: [
                                orders.saveLocalChanges
                            ],
                            no: []
                        }
                    ]
                ],
                false: []
            }
        ]
    ],
    applyLocalChanges,

    uploadResultDocument: [
        utils.set(ordersComputedActions.PATHS.isLoadingUploadResultDocument, true),
        utils.unset(currentOrderActions.PATHS.isShowUploadResultFailTooltip),
        [
            documents.uploadResultDocument,
            {
                success: [
                    ...applyLocalChanges,
                    utils.unset(currentOrderActions.PATHS.isShowUploadResultFailTooltip)
                ],
                errorTooBigFile: [
                    utils.set(currentOrderActions.PATHS.isShowUploadResultFailTooltip, true)
                ],
                error: [error.internalError('documents.uploadDocument')]
            }
        ],
        utils.set(ordersComputedActions.PATHS.isLoadingUploadResultDocument, false)
    ],

    licenseAccepted: [
        orders.setOrderUpdateProperty,
        utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showLicenseMustBeAccepted'], false)
    ],
    deleteDocument: [
        [
            utils.isLocalEditMode,
            {
                true: [
                    documents.deleteDocumentLocal
                ],
                false: [
                    [
                        documents.deleteDocument,
                        {
                            success: [documents.deleteDocumentFromState],
                            error: [error.internalError('documents.deleteDocument')]
                        }
                    ]
                ]
            }
        ]
    ],
    deleteResultDocument: [
        [
            documents.deleteDocument,
            {
                success: [
                    ...applyLocalChanges
                ],
                error: [error.internalError('documents.deleteDocument')]
            }
        ]
    ],
    downloadFile: [
        [
            orders.isDownloadingExportResult,
            {
                yes: [analytics.argsValueEvent({ category: 'start_downloading_fetching', action: 'see' })]
            },
            orders.downloadFile,
            {
                exportResultDownloaded: [
                    analytics.argsValueEvent({ category: 'finish_downloading_fetching', action: 'see' })
                ],
                error: [error.internalError('orders.downloadFile')]
            }
        ]
    ],

    downloadAll: [
        utils.toggleElementById('export-result-download-all-button'),
        [
            orders.downloadAll,
            {
                success: [],
                error: [error.internalError('orders.downloadAll')]
            }
        ],
        utils.toggleElementById('export-result-download-all-button'),
        utils.setElementVisibilityById('download-all-progress-bar', 'hidden')
    ],

    downloadDraftFile: [
        orders.downloadDraftFile,
        {
            ok: [],
            error: [error.internalError('orders.downloadDraftFile')]
        }
    ],

    selectUser: [
        orders.selectUser,
        [
            utils.isLocalEditMode,
            {
                true: [
                    utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'], false)
                ],
                false: [
                    ...currentOrderGroups.setUserGroup
                ]
            }
        ]
    ],

    selectManager: [
        orders.selectManager,
        [
            utils.isLocalEditMode,
            {
                true: [],
                false: [
                    [
                        orders.setManager,
                        {
                            success: [],
                            error: []
                        }
                    ]
                ]
            }
        ]
    ],

    selectOrderType: [
        orders.selectOrderType
    ],

    selectPaymentType: [
        [
            utils.isLocalEditMode,
            {
                true: [
                    orders.selectPaymentType,
                    orders.setPaymentTypeId,
                    [
                        utils.isSaveLocalChanges,
                        {
                            yes: [
                                orders.saveLocalChanges
                            ],
                            no: []
                        }
                    ]
                ],
                false: [
                    orders.selectPaymentType,
                    [
                        orders.setPaymentType,
                        {
                            success: [
                                currentOrder.updateOrder(['paymentTypeId', 'necessaryDocuments']),
                                utils.unset(['account', 'orders', 'currentOrder', 'localChanges',
                                    'selectedPaymentTypeId'])
                            ],
                            error: []
                        }
                    ]
                ]
            }
        ]
    ],
    setPaymentType: [
        [
            orders.isPaymentTypeChanged,
            {
                true: [
                    [
                        orders.setPaymentType,
                        {
                            success: [
                                currentOrder.updateOrder(['paymentTypeId', 'necessaryDocuments']),
                                utils.unset(['account', 'orders', 'currentOrder', 'localChanges',
                                    'selectedPaymentTypeId'])
                            ],
                            error: []
                        }
                    ]
                ],
                false: []
            }
        ]
    ],
    togglePopup: [
        utils.togglePopupFromArgs
    ],
    repeatOrder: [
        content.setIsLoading(true),
        [
            orders.repeatOrder,
            {
                success: [
                    ...updateOrderData,
                    currentOrder.addCurrentOrderToList
                ],
                error: [error.internalError('orders.repeatOrder')]
            }
        ],
        content.setIsLoading(false),
        utils.setArg('category', 'button_repeat_order'),
        utils.setArg('action', 'click'),
        analytics.raiseArgsValueEvent
    ],

    nameInputText: [
        form.inputText,
        [
            orders.debouncedSetName,
            {
                success: [
                    currentOrder.updateOrder(['name'])
                ],
                error: [error.internalError('orders.debouncedSetName')]
            }
        ]
    ],

    amountInputText: [
        form.inputText,
        form.validateText,
        utils.set(currentOrderActions.PATHS.showPriceMustBeBiggerThanZero, false),
        [
            orders.debouncedUpdateOrderAmount,
            {
                success: [
                ],
                error: [error.internalError('orders.debouncedUpdateOrderAmount')]
            }
        ]
    ],

    amountInputBlur: [
        form.trimText,
        form.validateText
    ],

    nameBlurText: []
};



// WEBPACK FOOTER //
// ./signals/account/orders.js